export default __webpack_public_path__ + "static/media/header-m.95ea0671.png";